import React from 'react';
import classnames from 'classnames';

import Layout from 'sections/Layout';
import Hero from 'sections/GuidePost/Hero';
import Content from 'sections/TemplatePost/Content';

import * as styles from 'styles/pages/template-post.module.scss';

const GuidePost = ({ guidePost, ...props }) => {
  const { content, title, excerpt, tags, language, guide, uri, seo } = guidePost
    ? guidePost
    : props.guide;

  const contentHead = {
    title: title,
    excerpt: excerpt,
  };

  const pageUrl = seo.canonical || uri;

  return (
    <Layout
      seo={seo}
      headerDarkColor={true}
      headerWhiteBg={true}
      requestButtonBlue={true}
      // ogImage={sourceUrl}
    >
      {(commonData) => (
        <>
          <div>
            <Hero tags={tags} data={guide} pageUrl={pageUrl} lang={language} />

            <div className={classnames(styles.wrapContent)}>
              {content ? (
                <Content data={content} contentHead={contentHead} />
              ) : null}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default GuidePost;
